/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var IndexType;
(function (IndexType) {
    IndexType["FOUNDATIONAL"] = "foundational";
    IndexType["FUNCTIONAL"] = "functional";
    IndexType["SPECIFIC"] = "specific";
    IndexType["OVERRIDE"] = "override";
    IndexType["AGENT_KNOWLEDGE"] = "agent-knowledge";
})(IndexType || (IndexType = {}));
